<style scoped>

	iframe {
		height:1000px;
		width:1600px;
	}
</style>
<template>
<div v-if="costing.lines" class="project-costing">
   <div class="costing-top">
		<div class="costing-title">
			<h1>Project Costing</h1>
		</div>
		<div class="costing-variables">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group row">
						<label class="control-label col-5">Effort Rate</label>
						<div class="col-7">
							<div class="input-group">
								<input type="text" class="form-control" v-model="costing.effort_rate" @blur="saveCosting" />
								<span class="input-group-text">
									hour per unit
								</span>
							</div>
						</div>
					</div><!-- /.form-group -->
				</div>
				<div class="col-md-6">
					<div class="form-group row">
						<label class="control-label col-5">Bugs &amp; Client Changes</label>
						<div class="col-7">
							<div class="input-group">
								<input type="text" class="form-control" v-model="costing.bugs" @blur="saveCosting"/>
								<span class="input-group-text">
									%
								</span>
							</div>
						</div>
					</div><!-- /.form-group -->
				</div>
				<div class="col-md-6">
					<div class="form-group row">
						<label class="control-label col-5">Project Management</label>
						<div class="col-7">
							<div class="input-group">
								<input type="text" class="form-control" v-model="costing.project_management" @blur="saveCosting"/>
								<span class="input-group-text">
									%
								</span>
							</div>
						</div>
					</div><!-- /.form-group -->
				</div>
				<div class="col-md-6">
					<div class="form-group row">
						<label class="control-label col-5">Hourly Rate</label>
						<div class="col-7">
							<div class="input-group">
								<span class="input-group-text">
									$
								</span>
								<input type="text" class="form-control" v-model="costing.hour_rate" @blur="saveCosting"/>
								<span class="input-group-text">
									/hr
								</span>
							</div>
						</div>
					</div><!-- /.form-group -->
				</div>
			</div><!-- /.row -->
		</div><!-- /.costing-variables -->
		<div class="costing-amount">
			<div class="left">
				<!-- <button type="button" class="btn btn-fab btn-gradient-primary dropdown-toggle" data-bs-toggle="dropdown">
					<i class="far fa-plus"></i>
				</button> -->

				<div class="btn-group">
					<button type="button" class="btn btn-fab btn-gradient-primary dropdown-toggle" v-dropdown aria-haspopup="true" aria-expanded="false">
						<i class="far fa-plus"></i>
					</button>
					<ul class="dropdown-menu">
						<li><a href="#" class="dropdown-item" @click.prevent="addFeature">Optional Feature</a></li>
						<li><a href="#" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#myModal">Group</a></li>
					</ul>
				</div>

			</div>
			<div class="right">
				<p>
					$ {{costing.total_ex | currency}}
					<small>Ex GST</small>
				</p>
			</div>
		</div><!-- /.costing-amount -->
	</div><!-- /.costing-top -->

	<div class="table-wrapper">
		<div class="table-scroller">

			<table class="table table-costing">
				<tbody>
					<tr class="area-name">
						<th>

						</th>
						<td>
							<span class="area-title">Base Effort</span>
						</td>
						<td>
							<span class="area-title">Hours</span>
						</td>
						<td>
							<span class="area-title">Bugs &amp;<br /> Changes</span>
						</td>
						<td>
							<span class="area-title">Management</span>
						</td>
						<td>
							<span class="area-title">Total Hours</span>
						</td>
						<td>
							<span class="area-title">Cost</span>
						</td>
					</tr>
				</tbody>

				<draggable :element="'tbody'" v-model="costing.lines" class="dragArea" :options="{group:'draggable', ghostClass: 'ghost-class', handle: '.dragRow'}" @update="epicsReordered">
					<costing-line v-for="(line, index) in costing.lines" :key="line.id" :project="project" :costing="costing" :line="line"  :index="index" ></costing-line>
				</draggable>

			</table>

		</div><!-- /.table-scroller -->
	</div><!-- /.table-wrapper -->


	 <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">Userstory Groups</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
			  <div v-if="costing.user_story_document.groups.length">
				  <p><i>Select a group to add it to this costing.</i></p>
			  	<span class="badge bg-light text-dark me-1 group-select" @click="groupSelected(group.id)" v-bind:key="group.id" v-for="group in costing.user_story_document.groups" >{{group.text}}</span>
			  </div>

			  <div v-else>
				  No groups available in this project.
			  </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

</div>
</template>

<script>
    //http://stackoverflow.com/documentation/javascript/4742/same-origin-policy-cross-origin-communication/30128/safe-cross-origin-communication-with-messages#t=201705171403471400655
//<div id="iframe-wrapper" style="position: absolute; width: 100%; height: 100%; top: 0px; background-color: #c3c3c3; z-index: 1000; opacity: 0.4;"><i class="fa fa-sticky-note" style=" font-size: 24px; z-index: 1005; position: absolute; top: 100px; left: 100px; color: red;"></i></div>
	import { mapState } from 'vuex'
	import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
	import { notify } from 'utils'
	import CostingLine from 'components/projects/project/stage2/CostingLine.vue'
	import draggable from 'vuedraggable'

    export default {
        components: {
            LaddaButton,
            Datepicker,
			Selectize,
			draggable,
      		CostingLine
		},

        data: function () {
            return {
            	edit: false,
            	loading: false,
				users: [],
				costing: {}
            }
        },

        computed: {
			...mapState('yodizproject', {
				project: 'single'
			}),

        	'api': function() {
        		return process.env.VUE_APP_API_URL;
			},
			'total_effort': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.base_effort;
				})

				return total;
			},
			'total_group_hours': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.hours;
				})

				return total;
			},
			'total_bugs': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.bugs;
				})

				return total.toPrecision(2);
			},
			'total_management': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.management;
				})

				return total.toPrecision(2);
			},
			'total_hours': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.total_hours;
				})

				return total;
			},
			'total_cost': function() {
				var total = 0

				this.costing.lines.forEach(function(line) {
					total += line.total_ex;
				})

				return total;
			}
        },
		mounted () {

			this.reload();

			var that = this

			this.$bus.$on('reload', function (id) {
				that.reload();
			})
		},
        methods: {
			groupSelected(groupId) {

				var that = this;
                this.loading = true;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/group', entity: {'group_id': groupId}, method: 'POST'}).then(
                    function(response) {
						that.reload();
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                        }
                    }

                )
			},
			reload() {
				var that = this;

				client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing'}).then(
					(response) => {
						that.costing = response.entity
					},
					(response) => {

					}
				)
			},
			saveCosting() {

				var that = this;
                this.loading = true;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id, entity: this.costing, method: 'PUT'}).then(
                    function(response) {
						that.reload();
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )
			},
			addFeature() {

				var that = this;
                this.loading = true;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/feature', entity: this.costing, method: 'POST'}).then(
                    function(response) {
						that.reload();
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )
			},
			saveLineOrder () {
				var that = this

				return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/lines/order', entity: this.lineOrderArray(), method: 'PUT'}).then(
					function(response) {

					that.reload();
					},
					function(response) {

					}
				)
			},
		epicsReordered (event) {
        	this.saveLineOrder()
	  },
	  lineOrderArray () {
        var lineOrderArray = []

        for (var i = 0; i < this.costing.lines.length; i++) {
          var line = this.costing.lines[i]

          lineOrderArray.push({id: line.id})
        }

        return {
          lines: lineOrderArray
        }
      },
            saveProject: function() {

            	var that = this;
                this.loading = true;

                return client({path: '/projects/'+this.project.id, entity: this.project, method: 'PUT'}).then(
                    function(response) {
                    	that.$emit('update:project', response.entity)
                    	that.edit = false
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )

            	this.edit = false;
            },
            confirmDelete(projectId) {
                var that = this;

                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: 'Are you sure you want to delete this project',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then(function() {
                        that.deleteProject(projectId);
                    }, function() {
                });

            },

            deleteProject (projectId) {
                var that = this;

                return client({path: '/projects/'+projectId, method: 'DELETE'}).then(
                    function(response) {
                        that.$router.push({ name: 'projects.index' })

                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                            notify.error(firstValidationIssue)
                        } else {
                            notify.error('Error deleting project')
                        }
                    }
                )
            },
        }
    }
</script>
